/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * {Document Title}
 * {Description}
 */

( function( window, $ ) {
    'use strict';
    var document = window.document;
    var request;
    var link_is_loading = false;

    var loadMorePost = {

        init: function() {
            $(document).on('click', '.btn-load-more-posts', (function (e) {
                var $args_posts = $(this);
                var current_cat = $('.category-selector').val();
                check_news_data();

                $('#page').addClass('loading_page');

                request = $.ajax({
                    method: "POST",
                    url: ajaxurl,
                    data: {
                        action: 'load_more_posts',
                        page: news_data[current_cat].current_page,
                        cat: current_cat,
                        current_post: $args_posts.data('current-post-id'),
                        language: language,
                        posts_per_page: $args_posts.data('posts-per-pages')
                    },
                    dataType: 'json'
                });

                request.done(function (data) {
                    link_is_loading = false;
                    $('.sidebar__news').append(data.content);

                    news_data[current_cat].current_page++;

                    if (news_data[current_cat].current_page + 1 >= data.max_num_pages) {
                        $('.btn-load-more-posts').remove();
                    }

                    $('.sidebar__news').append($('.btn-load-more-posts'));
                    $('#page').removeClass('loading_page');
                    set_news_data();
                });

                request.fail(function (jqXHR, textStatus) {
                    link_is_loading = false;
                    $('#page').removeClass('loading_page');
                });
            }));

            function set_news_data() {
                check_news_data();

                if ($('.category-selector').val() !== undefined) {
                    news_data[$('.category-selector').val()].data = $('.sidebar__news').html();
                }

                $('.sidebar__news-container').removeClass('current');
                $('.sidebar__news-container[data-post-id="' + $('article.single-post').data('current-post-id') + '"]').addClass('current');
                $('.sidebar__news-container.current').append($('progress.reading-progress'));
            }

            function get_news_data(pcat) {
                var current_cat = pcat || $('.category-selector').val();

                check_news_data();

                if (current_cat !== undefined && news_data[current_cat].data !== undefined) {
                    $('.sidebar__news').html(news_data[current_cat].data);
                    $('.category-selector').val(current_cat);

                    set_news_data();
                }
            }

            function check_news_data(pcat) {
                var current_cat = pcat || $('.category-selector').val();
                if (news_data[current_cat] === undefined && $('.category-selector').val() !== undefined) {
                    news_data[current_cat] = [];
                    news_data[current_cat].data = $('.sidebar__news').html();
                    news_data[current_cat].current_page = 1;
                }
            }

            $(function () {
                if (current_menu_element) {
                    page_data[window.location.href] = { title: $('title').html(), content: $('#page-content').html(), menu: $('#main-menu').html(), menu_element: current_menu_element };
                    set_news_data();
                    $('#main-menu a[data-menu-element="' + current_menu_element + '"]').parent().addClass("current-menu-item current_page_item");
                }
            });
        }

    };

    $(document).ready(function(){
        loadMorePost.init();
    });

} )(window,jQuery);